import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./content-menu.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./content-menu.component.scss?ngResource";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { UserInformationService } from "../../services/user/user-information.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AppControllerService } from "../../../app-controller.service";
export let ContentMenuComponent = class ContentMenuComponent {
    router;
    userInformationService;
    route;
    appControllerService;
    pageHeading;
    menuItems;
    relativeLinks = true;
    selectedModule;
    selectedModuleName = "";
    selectedOrganisationName = "";
    constructor(router, userInformationService, route, appControllerService) {
        this.router = router;
        this.userInformationService = userInformationService;
        this.route = route;
        this.appControllerService = appControllerService;
        this.selectedModule = this.userInformationService.getModuleInformation(+this.appControllerService.selectedModuleID);
        this.selectedModuleName = this.selectedModule?.name;
        this.selectedOrganisationName = this.selectedModule?.organisation?.name;
        this.checkState();
    }
    ngOnInit() {
    }
    routeToMenuItem(menuItem) {
        if (this.relativeLinks) {
            this.router.navigate([menuItem.address], { relativeTo: this.route });
        }
        else {
            this.router.navigate([menuItem.address]);
        }
    }
    checkState() {
        if (this.menuItems && this.pageHeading) {
            return;
        }
    }
    static ctorParameters = () => [
        { type: Router },
        { type: UserInformationService },
        { type: ActivatedRoute },
        { type: AppControllerService }
    ];
    static propDecorators = {
        pageHeading: [{ type: Input }],
        menuItems: [{ type: Input }],
        relativeLinks: [{ type: Input }]
    };
};
ContentMenuComponent = __decorate([
    Component({
        selector: "app-content-menu",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ContentMenuComponent);
